import { apiClient } from "./client";

export async function getServers(id) {
  const res = await apiClient.post("/dash/user/getservers", { id });
  return res.data;
}

export async function addServer({ server, iikoPass, id, login, name }) {
  const res = await apiClient.post("/dash/user/addiikoserver", {
    server,
    iikoPass,
    id,
    login,
    name,
  });
  return res.data;
}

export async function deleteServer(id) {
  const res = await apiClient.post("/dash/user/deleteserver", { id });
  return res.data;
}

